import script from "./LKProjectCardNew.vue?vue&type=script&setup=true&lang=js"
export * from "./LKProjectCardNew.vue?vue&type=script&setup=true&lang=js"

import "./LKProjectCardNew.vue?vue&type=style&index=0&id=4714e07c&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4714e07c"]])

export default __exports__